// extracted by mini-css-extract-plugin
module.exports = {"data-item-container":"InfoCard_data-item-container__3vJb1","data-item-content":"InfoCard_data-item-content__31Kfv","row":"InfoCard_row__2VnWN","total":"InfoCard_total__2Ygum"};